//
//
//
//
//
//
//
//

import BaseLoading from '@/components/BaseLoading';
require('@/assets/data_database_icon_177024.png');
import LineageBi from '@/modules/tasks/powerbi/components/LineageBI.vue';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
export default {
  name: 'ReportTabLineage',
  components: {
    BaseLoading: function BaseLoading() {
      return import('@/components/BaseLoading');
    },
    LineageBi: LineageBi
  },
  props: {
    report: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {},
  data: function data() {
    return {
      dataset: {},
      reports: {},
      data_lineage: {},
      isLoading: false
    };
  },
  created: function created() {
    console.log("created ReportTabLineage");
  },
  mounted: function mounted() {
    var _this = this;
    console.log("mounted ReportTabLineage");
    this.isLoading = true;
    Promise.all([this.getReports(), this.getDataset()]).then(function (values) {
      console.log(values);
      _this.isLoading = false;
    });
  },
  methods: {
    getDataset: function getDataset() {
      var _this2 = this;
      var consulta = {
        'dataset_id': this.report.dataset_id
      };
      return BiDatasetService.getDatasetById(consulta).then(function (response) {
        console.log(response);
        _this2.data_lineage = {
          dataset: {
            'object_name': response.data.object_name
          },
          tables: response.data.tables,
          reports: _this2.data_lineage.reports
        };
      });
    },
    getReports: function getReports() {
      var _this3 = this;
      var consulta = {
        'dataset_id': this.report.dataset_id
      };
      return BiDatasetService.getReports(consulta).then(function (response) {
        response.data.forEach(function (x) {
          if (x.report_id == _this3.report.report_id) {
            x.focus = true;
          }
        });
        _this3.data_lineage = {
          dataset: _this3.data_lineage.dataset,
          tables: _this3.data_lineage.tables,
          reports: response.data
        };
      });
    }
  }
};